import * as fromActions from '../actions/externalCourses.action'
import { Reducer } from 'redux'
import { IExternalCoursesState } from 'store/states/externalCourses.state'
import { ExternalCourseModelAPI } from '../../models/externalCourse.model'

export const initialState: IExternalCoursesState = {
  list: [],
  total: 0,
  perPage: 0,
  sort: [],
  loading: true,
  externalCourse: { loading: false },
}

type AdministrationListSuccess = {
  type: typeof fromActions.EXTERNAL_COURSES_ADMINISTRATION_GET_LIST_SUCCESS
  payload: {
    data: ExternalCourseModelAPI[]
    total: number
    perPage: number
    sort: any[]
  }
}

type Loading = {
  type:
    | typeof fromActions.EXTERNAL_COURSES_ADMINISTRATION_GET_LIST
    | typeof fromActions.DESTROY_EXTERNAL_COURSE
    | typeof fromActions.EDIT_EXTERNAL_COURSE
    | typeof fromActions.GET_EXTERNAL_COURSE
    | typeof fromActions.GET_ADMIN_EXTERNAL_COURSE
    | typeof fromActions.EXTERNAL_COURSES_SET_LOADING
    | typeof fromActions.EXTERNAL_COURSE_LOADING
  payload: {
    loading: boolean
  }
}

type ExternalCourse = {
  type: typeof fromActions.GET_EXTERNAL_COURSE_SUCCESS
  payload: ExternalCourseModelAPI
}

type Empty = {
  type: typeof fromActions.DESTROY_EXTERNAL_COURSES
  payload: void
}

export type ReducerActions =
  | AdministrationListSuccess
  | Loading
  | ExternalCourse
  | Empty

export const reducer: Reducer<IExternalCoursesState, ReducerActions> = (
  state: IExternalCoursesState = initialState,
  action
): IExternalCoursesState => {
  switch (action.type) {
    case fromActions.EXTERNAL_COURSES_ADMINISTRATION_GET_LIST_SUCCESS: {
      const { data, total, perPage, sort } = action.payload
      return {
        ...state,
        list: data,
        total,
        perPage,
        sort,
        loading: false,
      }
    }
    case fromActions.EXTERNAL_COURSES_ADMINISTRATION_GET_LIST:
    case fromActions.DESTROY_EXTERNAL_COURSE:
    case fromActions.EDIT_EXTERNAL_COURSE:
    case fromActions.GET_ADMIN_EXTERNAL_COURSE:
    case fromActions.GET_EXTERNAL_COURSE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.EXTERNAL_COURSES_SET_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case fromActions.EXTERNAL_COURSE_LOADING: {
      const { loading } = action.payload
      const { externalCourse } = state
      return {
        ...state,
        externalCourse: {
          ...externalCourse,
          loading,
        },
      }
    }
    case fromActions.GET_EXTERNAL_COURSE_SUCCESS:
      return {
        ...state,
        externalCourse: { loading: false, data: action.payload },
        loading: false,
      }

    default:
      return state
  }
}
